import { jsx as _jsx } from "react/jsx-runtime";
import List from "components/Lists/List";
import DELETE_EMAILS_FOOTERS from "mutations/emails/deleteEmailsFooter";
import GET_EMAILS_FOOTERS from "queries/emails/getEmailsFooters";
const FootersList = () => (_jsx(List, { deleteMutation: DELETE_EMAILS_FOOTERS, itemNamePlural: "footers", label: "Footers", listQuery: GET_EMAILS_FOOTERS, listQueryDataName: "getEmailsFooters", pathPrefix: "/emails" }));
export default FootersList;
